import { Text, Pressable } from "react-native";
import { Icon } from "ui/gluestack/icon";
import { CameraIcon } from "ui/gluestack/icon/Camera";
import * as DocumentPicker from "expo-document-picker";
import { useDisplayToast } from "ui/hooks/useDisplayToast";

interface Props {
  onChange: (file: DocumentPicker.DocumentPickerAsset[] | undefined) => void;
  inputRef: React.RefObject<HTMLInputElement>;
  allowedExtensions?: string[];
}

export function UploadArea({ onChange, inputRef, allowedExtensions }: Props) {
  const { showErrorToast } = useDisplayToast();

  const pickFile = async () => {
    try {
      const result = await DocumentPicker.getDocumentAsync({
        type: allowedExtensions,
        copyToCacheDirectory: true,
      });

      if (!result.canceled && result.assets) {
        onChange(result.assets);
      }
    } catch (error) {
      showErrorToast(error);
    }
  };

  return (
    <Pressable
      onPress={pickFile}
      className="flex flex-col items-center justify-center h-full w-full cursor-pointer absolute top-0 left-0"
    >
      <Icon as={CameraIcon} className="w-7 h-7 text-primary-500" />
      <Text className="text-xs font-medium text-primary-600 mt-2">Upload</Text>
    </Pressable>
  );
}
